import React from 'react';
import { NavLink } from 'react-router-dom';

export default class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuIsOpen: false,
      menuState: '',
      iconState: 'iconShowOpen'
    };
    this.handleMenuOpen = this.handleMenuOpen.bind(this);
    this.handleMenuClose = this.handleMenuClose.bind(this);
    this.handleMouseEnterIcon = this.handleMouseEnterIcon.bind(this);
  }

  handleMenuOpen() {
    this.setState({ 
      menuIsOpen: !this.state.menuIsOpen,
      menuState: !this.state.menuIsOpen ? 'menuIsOpen' : 'menuIsClose',
      iconState: !this.state.menuIsOpen ? 'iconShowClose' : 'iconShowOpen'
    });
  }

  handleMenuClose() {
    this.setState({
      menuIsOpen: false,
      menuState: '',
      iconState: 'iconShowOpen'
    });
  }
  
  handleMouseEnterIcon() {
    if (this.state.iconState === 'iconShowClose') {
      this.setState({
        menuIsOpen: true,
        menuState: 'menuIsOpen',
        iconState: 'iconShowClose'
      });
    } 
  }

  render() {
    return (
      <div id="nav-bar" className="dark-bg">
        <NavLink to="/"><div id="web-name">資訊農業化</div></NavLink>
        <div id="menu-button" className={this.state.iconState}
          onClick={() => this.handleMenuOpen()}
          onMouseEnter={() => this.handleMouseEnterIcon()} >
            <div></div>
            <div></div>
            <div></div>
        </div>
        <nav>
          <ul className={this.state.menuState} 
              onMouseLeave={() => this.handleMenuClose()}>
            <NavLink to="/about" 
              onClick={() => this.handleMenuClose()}>
              <li id="nav-about">關於</li></NavLink>
            <NavLink to="/vegitables" 
              onClick={() => this.handleMenuClose()}>
              <li id="nav-vagitables">蔬菜類</li></NavLink>
            <NavLink to="/fruits" 
              onClick={() => this.handleMenuClose()}>
              <li id="nav-fruits">水果類</li></NavLink>
            <NavLink to="/grains" 
              onClick={() => this.handleMenuClose()}>
              <li id="nav-grains">雜糧類</li></NavLink>
            <NavLink to="/special" 
              onClick={() => this.handleMenuClose()}>
              <li id="nav-special">特作類</li></NavLink>
            <NavLink to="/flowers" 
              onClick={() => this.handleMenuClose()}>
              <li id="nav-flowers">花卉類</li></NavLink>
            <NavLink to="daily"
              onClick={() => this.handleMenuClose()}>
              <li id="nav-daily">今日批價</li></NavLink>
          </ul>
        </nav>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/layouts/navbar.js